import { serviceNameValues, packageValues, packageValuesToPriceValues } from './common';

export default {
  [serviceNameValues.BUILD_YOUR_DREAM_SITE]: [
    {
      value: packageValues.BASIC_WEBSITE,
      title: 'Basic website',
      subTitle: packageValuesToPriceValues[packageValues.BASIC_WEBSITE],
      description:
        'A single-page design with key details, appealing visuals, and a powerful call to action',
    },
    {
      value: packageValues.ADVANCED_WEBSITE,
      title: 'Advanced website',
      subTitle: packageValuesToPriceValues[packageValues.ADVANCED_WEBSITE],
      description: 'A 5-7 page website showcasing your business, services, testimonials, and more',
    },
    {
      value: packageValues.CUSTOM_WEBSITE,
      title: 'Custom website',
      description:
        'A fully personalized website tailored to your unique needs, including specialized functionality (event booking, online store, 3rd party integrations)',
      subDescription: 'Pricing is tailored based on your specific requirements',
    },
  ],
  [serviceNameValues.REVAMP_YOUR_WEBSITE]: [
    {
      value: packageValues.REFRESH_AND_REFINE,
      title: 'Refresh & refine',
      subTitle: packageValuesToPriceValues[packageValues.REFRESH_AND_REFINE],
      description:
        'Enhance your existing website with a professional facelift and revitalizing its design while maintaining its core functionality',
    },
    {
      value: packageValues.TRANSFORM_AND_INNOVATE,
      title: 'Transform & innovate',
      subTitle: packageValuesToPriceValues[packageValues.TRANSFORM_AND_INNOVATE],
      description:
        'Get a complete website transformation with a deep revamp, introducing new features, modern layouts, and a fresh design',
    },
  ],
  [serviceNameValues.MIGRATE_YOUR_SITE_TO_YOLA]: [
    {
      value: packageValues.WEBSITE_MIGRATION,
      title: 'Website migration',
      subTitle: packageValuesToPriceValues[packageValues.WEBSITE_MIGRATION],
      description:
        'Get your website migrated to Yola while preserving its core elements (includes visual refreshment if needed)',
    },
    {
      value: packageValues.MIGRATION_AND_REVAMP,
      title: 'Migration & revamp',
      subTitle: packageValuesToPriceValues[packageValues.MIGRATION_AND_REVAMP],
      description:
        'Enhance your website migration experience with a deep revamp, adding new features, and refreshing design to match the new platform',
    },
  ],
};
